__turbopack_context__.v({
  "react_time": "ReactTime-module-scss-module__4aSYcq__react_time",
  "react_time__animating": "ReactTime-module-scss-module__4aSYcq__react_time__animating",
});
